import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  '@keyframes dots-white': {
    "0%, 20%": {
      color: "rgba(255,255,255,0)",
      textShadow: ".25em 0 0 rgba(255,255,255,0), .5em 0 0 rgba(255,255,255,0)"
    },
    "40%": {
      color: "rgba(255,255,255,1)",
      textShadow: ".25em 0 0 rgba(255,255,255,0), .5em 0 0 rgba(255,255,255,0)"
    },
    "60%": {
      textShadow: ".25em 0 0 rgba(255,255,255,1), .5em 0 0 rgba(255,255,255,0)"
    },
    "80%, 100%": {
      textShadow: ".25em 0 0 rgba(255,255,255,1), .5em 0 0 rgba(255,255,255,1)"
    }
  },
  '@keyframes dots-black': {
    "0%, 20%": {
      color: "rgba(0,0,0,0)",
      textShadow: ".25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0)"
    },
    "40%": {
      color: "rgba(0,0,0,1)",
      textShadow: ".25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0)"
    },
    "60%": {
      textShadow: ".25em 0 0 rgba(0,0,0,1), .5em 0 0 rgba(0,0,0,0)"
    },
    "80%, 100%": {
      textShadow: ".25em 0 0 rgba(0,0,0,1), .5em 0 0 rgba(0,0,0,1)"
    }
  },
  dots: {
    fontSize: (props) => props.fontSize ? props.fontSize + "px" : "16px",
    marginLeft: (props) => props.marginLeft ? props.marginLeft + "px" : "0px",
    minWidth: "15px",
    display: "inline-block",
    color: (props) => props.color === "white" ? "#ffffff" : "#000000",
    "&:after": {
      content: '" ."',
      animation: (props) => props.color === "white" ? '$dots-white 1s steps(5, end) infinite' : '$dots-black 1s steps(5, end) infinite'
    }
  }
});

const Dots = (props) => {

  const classes = useStyles(props);

  return (
    <div className={classes.dots}></div>
  );
}

export default Dots;